// Round avatar: the account image when present (and it loads), otherwise
// the user's initials on a gold disc.

import { cn } from '@aod/ui/lib/utils';
import { useState } from 'react';
import { type SessionUser, initialsFor } from '../../auth/session.js';

export function UserAvatar({
  user,
  className,
}: {
  readonly user: SessionUser;
  readonly className?: string;
}) {
  const [broken, setBroken] = useState(false);
  const base =
    'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 ring-border';
  if (user.image && !broken) {
    return (
      <img
        src={user.image}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        className={cn(base, 'object-cover', className)}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={cn(
        base,
        'bg-primary text-[11px] font-semibold text-primary-foreground',
        className,
      )}
    >
      {initialsFor(user)}
    </span>
  );
}
